<ng-container>
    @if ((loading || !loadedOnce) && filteredData.length === 0 && !(loadError$ | async)) {
    <section class="skeleton" aria-busy="true">
        <span class="visually-hidden" role="status">Carregando</span>
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
        <div class="skeleton__card" aria-hidden="true">
            <span class="skeleton__avatar"></span>
            <span class="skeleton__lines"><span></span><span></span></span>
        </div>
        }
    </section>
    } @if (noRegister) {
    <section class="message">
        <h2>Nenhum registro encontrado</h2>
        @if (isFiltered) {
        <small>Nenhum registro corresponde aos critérios de busca</small>
        }
    </section>
    } @if (!loading && filteredData.length === 0 && (loadError$ | async); as err) {
    <section class="message error">
        <h2>{{ errorMessage }}</h2>
        @if (err?.status) {
        <small>HTTP {{ err.status }}</small>
        }
        <p class="error-actions">
            <a href="javascript:void(0)" (click)="invalidate()">Tentar novamente</a>
        </p>
    </section>
    } @if (filteredData.length > 0) { @if (lazyLoading) {
    <section
        #cards
        class="cards"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="200"
        [scrollWindow]="infiniteScrollWindow"
        (scrolled)="onScrollDown($event)"
    >
        @for (item of filteredData; track trackByFn(item)) {
        <ng-container
            *ngTemplateOutlet="
                $safeNavigationMigration(cardTemplate?.templateRef);
                context: { $implicit: item }
            "
        ></ng-container>
        } @if (loading && filteredData.length > 0) {
        <div class="loading-more">
            <mat-spinner diameter="30"></mat-spinner>
            <span>Carregando mais registros...</span>
        </div>
        }
        <div class="cards-footer">
            <span class="cards-count" role="status" aria-live="polite">
                Mostrando {{ filteredData.length | number }}
                @if (filteredTotal > filteredData.length) {
                de {{ filteredTotal | number }}
                }
            </span>
            @if (canLoadMore) {
            <button
                mat-stroked-button
                type="button"
                class="load-more"
                (click)="loadNextPage()"
                [disabled]="loading"
            >
                Carregar mais
            </button>
            }
            <!-- Sentinel: IntersectionObserver (viewport + .cards) — mobile e desktop -->
            <div #scrollSentinel class="scroll-sentinel" aria-hidden="true"></div>
        </div>
    </section>
    } @else {
    <section #cards class="cards">
        @for (item of filteredData; track trackByFn(item)) {
        <ng-container
            *ngTemplateOutlet="
                $safeNavigationMigration(cardTemplate?.templateRef);
                context: { $implicit: item }
            "
        ></ng-container>
        }
    </section>
    } }
</ng-container>
